
import Vue from "vue";
import ProgressiveImage from "@/components/ProgressiveImage.vue";
import { publicAssetUrls } from "@/utils/publicAsset";

const LAB_REL = "img/groups/lab.jpg";

export default Vue.extend({
  components: { ProgressiveImage },
  data: () => ({
    labPhotoFull: "",
    labPhotoThumb: "",
  }),
  created() {
    const urls = publicAssetUrls(LAB_REL);
    this.labPhotoFull = urls.full;
    this.labPhotoThumb = urls.thumb;
  },
});
